<template>
  <ResourceDialog
    @close="emit('close')"
    ref="dialogRef"
    :max-width="640"
    cancel-button-text="Cancel"
    title="Upload document"
    closeable
    hide-save-button
  >
    <template #form>
      <v-row dense>
        <LabeledSimpleSelect
          v-model="category"
          :items="categories"
          cols="12"
          message="Document category"
        />

        <LabeledDatePicker
          v-model="expiresAt"
          cols="12"
          message="Expiry date"
        />
      </v-row>

      <div
        v-if="category"
        class="mt-4"
        data-cy="staff_document_upload_uploader"
      >
        <AttachmentUploader
          @uploaded="handleUploaded"
          :owner="uploadOwner"
          dense
        />
      </div>

      <p
        v-else
        class="c-light-black fs-14 mt-4"
      >
        Select a document category before uploading.
      </p>
    </template>
  </ResourceDialog>
</template>

<script setup>
import AttachmentUploader from '@/shared/components/attachments/AttachmentUploader.vue';
import { formatExpiryNote } from '@/shared/utils/staffDocumentUtils';
import LabeledDatePicker from '@/shared/components/form/LabeledDatePicker.vue';
import LabeledSimpleSelect from '@/shared/components/form/LabeledSimpleSelect.vue';
import ResourceDialog from '@/shared/components/form/ResourceDialog.vue';

const props = defineProps({
  businessId: {
    type: String,
    default: null,
  },
  categories: {
    type: Array,
    default: () => [],
  },
  employmentId: {
    type: String,
    default: null,
  },
  initialCategory: {
    type: String,
    default: null,
  },
  openOnMount: {
    type: Boolean,
    default: false,
  },
  selfUpload: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['close', 'uploaded']);

const dialogRef = ref(null);
const category = ref(props.initialCategory);
const expiresAt = ref(null);

const uploadOwner = computed(() => ({
  business_id: props.businessId,
  category: category.value,
  id: props.employmentId,
  note: formatExpiryNote(expiresAt.value),
  self_upload: props.selfUpload,
  type: 'Employment',
}));

onMounted(load);

async function load() {
  if (!props.openOnMount) return;

  await nextTick();
  dialogRef.value?.open();
}

function open(selectedCategory = null) {
  category.value = selectedCategory || props.categories[0] || null;
  expiresAt.value = null;
  dialogRef.value?.open();
}

function handleUploaded(attachment) {
  emit('uploaded', attachment);
  dialogRef.value?.close();
  emit('close');
}

defineExpose({ open });
</script>
